import { isDesktop } from './desktop'
import { currentProfile } from './profiles'

/** The version this bundle was built as: one number for the web app and the desktop app alike. */
export const APP_VERSION = __APP_VERSION__

/** What is shown to people: "v0.2.0 · web" or "v0.2.0 · desktop", so a bug report says which. */
export function versionLabel(): string {
  // Another account's window says whose it is (docs/refactor/45).
  const profile = currentProfile()
  return `v${APP_VERSION} · ${isDesktop() ? 'desktop' : 'web'}${profile ? ` · ${profile}` : ''}`
}

/** Whether `theirs` is a strictly newer MAJOR.MINOR.PATCH than `mine`. Anything unparseable: no. */
export function isNewerVersion(mine: string, theirs: string): boolean {
  const parse = (v: string) => /^(\d+)\.(\d+)\.(\d+)$/.exec(v.trim())?.slice(1).map(Number) ?? null
  const a = parse(mine)
  const b = parse(theirs)
  if (!a || !b) return false
  for (let i = 0; i < 3; i++) {
    if (b[i]! > a[i]!) return true
    if (b[i]! < a[i]!) return false
  }
  return false
}
